/**
 * Step One Foods — Animated Results Timeline
 * Gold spine fills left→right (desktop) or top→bottom (mobile) as you scroll.
 * Each node lights up the moment the fill front reaches it.
 * Final node turns gold. prefers-reduced-motion: shows completed state immediately.
 */
(function () {
  'use strict';

  var DESKTOP_BP   = 760;          // px breakpoint matching CSS
  var GOLD_COLOR   = '#C4943A';
  var PLUM_COLOR   = '#511D4B';
  var RAIL_BG      = '#DDD5CC';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var tracks = document.querySelectorAll('[data-sof-timeline]');
    tracks.forEach(function (track) {
      setupTimeline(track);
    });
  }

  function setupTimeline(track) {
    var rail    = track.querySelector('[data-sof-rail]');
    var fill    = track.querySelector('[data-sof-fill]');
    var steps   = Array.from(track.querySelectorAll('[data-step]'));
    if (!rail || !fill || !steps.length) return;

    var isDesktop = function () { return window.innerWidth >= DESKTOP_BP; };

    // ── Style the rail container ──────────────────────────────────────────
    function styleRail(r) {
      r.style.position   = 'absolute';
      r.style.background = RAIL_BG;
      r.style.borderRadius = '2px';
      r.style.overflow   = 'hidden';
      r.style.pointerEvents = 'none';
      r.style.zIndex     = '0';
    }
    styleRail(rail);
    fill.style.background    = GOLD_COLOR;
    fill.style.borderRadius  = '2px';
    fill.style.transition    = 'none';

    // ── Measure and position the rail between node circle centres ─────────
    var thresholds = [];

    function measure() {
      var circles = steps.map(function (s) {
        return s.querySelector('.sof-timeline__circle');
      });

      var trackRect  = track.getBoundingClientRect();
      var firstRect  = circles[0].getBoundingClientRect();
      var lastRect   = circles[circles.length - 1].getBoundingClientRect();

      if (isDesktop()) {
        // Horizontal spine
        var startX = firstRect.left + firstRect.width  / 2 - trackRect.left;
        var endX   = lastRect.left  + lastRect.width   / 2 - trackRect.left;
        var midY   = firstRect.top  + firstRect.height / 2 - trackRect.top;
        var len    = endX - startX;

        rail.style.top    = (midY - 1.5) + 'px';
        rail.style.left   = startX + 'px';
        rail.style.width  = len + 'px';
        rail.style.height = '3px';
        fill.style.width  = '0';
        fill.style.height = '100%';

        thresholds = circles.map(function (c) {
          var cx = c.getBoundingClientRect().left + c.getBoundingClientRect().width / 2 - trackRect.left;
          return (cx - startX) / len;
        });

      } else {
        // Vertical spine
        var startY = firstRect.top  + firstRect.height / 2 - trackRect.top;
        var endY   = lastRect.top   + lastRect.height  / 2 - trackRect.top;
        var midX   = firstRect.left + firstRect.width  / 2 - trackRect.left;
        var lenV   = endY - startY;

        rail.style.left   = (midX - 1.5) + 'px';
        rail.style.top    = startY + 'px';
        rail.style.height = lenV + 'px';
        rail.style.width  = '3px';
        fill.style.height = '0';
        fill.style.width  = '100%';

        thresholds = circles.map(function (c) {
          var cy = c.getBoundingClientRect().top + c.getBoundingClientRect().height / 2 - trackRect.top;
          return (cy - startY) / lenV;
        });
      }
    }

    // ── Scroll handler ────────────────────────────────────────────────────
    function onScroll() {
      var rect = track.getBoundingClientRect();
      var vh   = window.innerHeight;

      // Start animating when the top of the track crosses 75% vh,
      // complete when the bottom of the track crosses 30% vh.
      var start    = vh * 0.75;
      var end      = rect.height * 0.85;
      var traveled = start - rect.top;
      var progress = Math.max(0, Math.min(1, traveled / end));

      if (isDesktop()) {
        fill.style.width = (progress * 100) + '%';
      } else {
        fill.style.height = (progress * 100) + '%';
      }

      steps.forEach(function (step, i) {
        var threshold = (thresholds[i] !== undefined) ? thresholds[i] : (i / Math.max(steps.length - 1, 1));
        if (progress >= threshold) {
          step.classList.add('is-active');
        } else {
          step.classList.remove('is-active');
        }
      });
    }

    // ── Complete state (reduced motion or no-JS fallback) ─────────────────
    function showComplete() {
      if (isDesktop()) {
        fill.style.width  = '100%';
        fill.style.height = '100%';
      } else {
        fill.style.height = '100%';
        fill.style.width  = '100%';
      }
      steps.forEach(function (s) { s.classList.add('is-active'); });
    }

    // ── Init ──────────────────────────────────────────────────────────────
    // Two rAF to ensure layout is complete before measuring
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        measure();
        if (prefersReduced) {
          showComplete();
        } else {
          onScroll();
        }
      });
    });

    if (!prefersReduced) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        measure();
        if (prefersReduced) {
          showComplete();
        } else {
          onScroll();
        }
      }, 100);
    });
  }

  // ── Boot ────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
